export default function authMiddleware({ next, router, store, app, privilege }) {
	// console.log('privilege -> ', privilege, store.getters['auth/allowedTo'](privilege));

	if (!store.state.auth.viewer) {
		app.$notify({
			group: 'app',
			title: 'Geen toegang',
			type: 'error',
			text: 'Je bent niet ingelogd'
		});
		return router.push({ name: 'login' });
	}

	if (!store.getters['auth/allowedTo'](privilege)) {
		app.$notify({
			group: 'app',
			title: 'Geen toegang',
			type: 'error',
			text: 'Je hebt niet genoeg rechten'
		});
		return router.push({ name: 'home' });
	}

	return next();
}
